import React, { useEffect, useState } from 'react';
import images from '../../../Utils/images';
import Form from 'react-bootstrap/Form';
import colors from '../../../Utils/colors';
import InputGroup from 'react-bootstrap/InputGroup';
import { IoIosCloseCircleOutline } from 'react-icons/io';
import CheerioButton from '../../../Components/CheerioButton';
import { Alert } from 'react-bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';


const disallowedKeywords = ['prev', 'back', 'exit', 'menu', 'stop'];

const AddKeywords = ({ index = 0, SetOptions, Options, nextClickAction }) => {
  const [inputValue, setInputValue] = useState('');
  const [keywords, setKeywords] = useState([]);
  const [criteria, setCriteria] = useState('exact'); // 'exact', 'approx', 'contextual'
  const [alertMessage, setAlertMessage] = useState('');
  const [error, setError] = useState('');
  const [sensitivity, setSensitivity] = useState(70); // only for contextual

  // Load once from Options
  useEffect(() => {
    const option = Options[index];
    if (option) {
      setKeywords(option.keywords || []);
      setCriteria(
        option.criteria === 'contextual match'
          ? 'contextual'
          : option.criteria === 'approx. match'
            ? 'approx'
            : 'exact'
      );
      if (option.sensitivity && option.criteria === 'contextual match') {
        setSensitivity(option.sensitivity);
      }
    }
  }, [Options, index]);

  useEffect(() => {
    if (alertMessage) {
      const timer = setTimeout(() => setAlertMessage(''), 2000);
      return () => clearTimeout(timer);
    }
  }, [alertMessage]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addKeyword(inputValue);
    }
  };

  const addKeyword = (keyword) => {
    const trimmed = keyword.trim();
    if (disallowedKeywords.includes(trimmed.toLowerCase())) {
      setAlertMessage(`The following keywords are not allowed: ${disallowedKeywords.join(', ')}`);
      return;
    }
    if (trimmed && !keywords.includes(trimmed)) {
      setKeywords((prev) => [...prev, trimmed]);
      setInputValue('');
      setError('');
    }
  };

  const removeKeyword = (item) => {
    setKeywords((prev) => prev.filter((k) => k !== item));
  };

  const handleNextClick = async () => {
    if (keywords.length === 0) {
      setError('Please add at least one keyword.');
      return;
    }

    if (inputValue.trim()) {
      addKeyword(inputValue);
      return; // Wait for keyword to be added before proceeding
    }

    SetOptions((prev) => {
      const updated = [...prev];
      updated[index] = {
        keywords,
        criteria:
          criteria === 'contextual'
            ? 'contextual match'
            : criteria === 'approx'
              ? 'approx. match'
              : 'exact match',
        ...(criteria === 'contextual' && { sensitivity }),
      };
      return updated;
    });

    nextClickAction();
  };

  return (
    <div className="addkeywords_container">
      <div className="addkeywords_container__header_row">
        <h4>Matching criteria</h4>
        <img className="image24" src={images.InfoCircleGrey} alt="info" />
      </div>

      <div className="addkeywords_container__match_row mb-3">
        <Form.Group controlId="matchTypeSelect">
          <Form.Label style={{ fontSize: 14, fontWeight: 400, color: colors.black }}>
            Match Type
          </Form.Label>
          <Form.Select
            value={criteria}
            onChange={(e) => setCriteria(e.target.value)}
            style={{ width: 200, fontSize: 14, fontWeight: 400, color: colors.black }}
          >
            <option value="exact">Exact Match</option>
            <option value="approx">Approx. Match</option>
            <option value="contextual">Contextual Match (AI)</option>
          </Form.Select>
        </Form.Group>
      </div>

      {criteria === 'contextual' && (
        <div className="mb-4" style={{ width: '100%', maxWidth: 400, marginInlineStart: 0, marginInlineEnd: 'auto' }}>
          <Alert variant="info" className="p-3 mb-3" style={
            {
              backgroundColor: colors.primary01,
              color: colors.primary04,
              border: "1px solid " + colors.primary04,
            }
          }>
            <strong>Contextual Match With AI:</strong> Uses semantic similarity to find matches even
            when keywords don't appear exactly. Adjust sensitivity to tune strictness.
            <br />
            <strong>Note:</strong> Use sensitivity 75-85 for best results.
          </Alert>

          <Form.Group controlId="sensitivitySlider">
            <div className="d-flex flex-column align-items-start w-100">
              <Form.Label className="mb-2">
                Sensitivity: <strong>{sensitivity}</strong>
              </Form.Label>
              <input
                type="range"
                min={1}
                max={100}
                value={sensitivity}
                onChange={(e) => setSensitivity(Number(e.target.value))}
                style={{
                  width: '100%',
                  height: '6px',
                  background: '#dee2e6',
                  borderRadius: '5px',
                  appearance: 'none',
                  WebkitAppearance: 'none',
                  MozAppearance: 'none',
                  outline: 'none',
                  cursor: 'pointer',
                }}
                onMouseOver={(e) => (e.target.style.opacity = '1')}
                className="slider-inline"
              />
            </div>
          </Form.Group>
        </div>
      )}

      <div className="d-flex flex-row flex-wrap justify-content-start align-items-center w-100 mb-2">
        {keywords.map((item) => (
          <div
            key={item}
            className="d-flex flex-row justify-content-center align-items-center px-3 py-1 my-1 me-2"
            style={{ backgroundColor: colors.white03, borderRadius: 10 }}
          >
            <p className="me-2 mb-0">{item}</p>
            <IoIosCloseCircleOutline onClick={() => removeKeyword(item)} />
          </div>
        ))}
      </div>

      {alertMessage && <Alert variant="danger">{alertMessage}</Alert>}

      <InputGroup>
        <Form.Control
          as="textarea"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyPress}
          disabled={keywords.length >= 10}
          style={{ resize: 'none' }}
          rows={4}
        />
      </InputGroup>

      {error && (
        <span style={{ color: colors.red49, fontSize: '0.875rem', marginTop: '0.5rem' }}>
          {error}
        </span>
      )}

      <div style={{ color: 'gray', fontSize: '0.875rem', marginTop: '0.5rem', justifySelf: 'flex-start', marginInlineStart: 0, marginInlineEnd: 'auto' }}>
        Press Enter to submit
      </div>

      <CheerioButton
        borderStyle={{
          borderWidth: 0,
          justifySelf: 'flex-start',
          marginBlock: 24,
          marginInlineStart: 0,
          marginInlineEnd: 'auto',
        }}
        textStyle={{
          fontWeight: 600,
          color: colors.white01,
        }}
        btnText="Next"
        backColor={colors.primary03}
        onclick={handleNextClick}
      />
    </div>
  );
};

export default AddKeywords;
